import { render } from "./ModalRemoveEmployees.vue?vue&type=template&id=2072d950"
import script from "./ModalRemoveEmployees.vue?vue&type=script&lang=js"
export * from "./ModalRemoveEmployees.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__